import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Drawer } from './components/drawer/drawer';
import { Modal } from './components/modal/modal';
import { DateRangePicker } from './components/date-range-picker/date-range-picker';
import { ImportPreviewModal } from './components/import-preview-modal/import-preview-modal';
import { GatewayConnectivityModal } from './components/gateway-connectivity-modal/gateway-connectivity-modal';

@NgModule({
  declarations: [Drawer, Modal, DateRangePicker, ImportPreviewModal, GatewayConnectivityModal],
  imports: [CommonModule],
  exports: [Drawer, Modal, DateRangePicker, ImportPreviewModal, GatewayConnectivityModal],
})
export class SharedModule {}
